/* eslint-disable max-len */
/* eslint-disable consistent-return */
import React, { useState } from 'react';
import { checkRole } from '../../../Common/CheckRole';
import { cookieStorageUtility } from '../../../../utils/utilityFunctions';

const isEzakey = cookieStorageUtility.fetch('isEzeykey');

const EditMapping = (props) => {
  const [showUILoader, setShowUILoader] = useState(false);
  const [showLogin, setShowLogin] = useState(true);
  const [showCategoryMapping, setShowCategoryMapping] = useState(false);
  const [showRateplanMapping, setShowRateplanMapping] = useState(false);
  const [systemRatePlan] = useState({
    'BAR': 'BAR+RF',
    'PNNRNBF': 'Room+Non Refundable + pay Now(BAR)',
    'PNNRBF': 'BAR+BF',
    'PAHRBF': 'BAR+PAH+BF',
    'PAHRNBF': 'BAR+PAH',
    'PNRBF': 'Bar+RF+BF'
  });
  const [loginScreenClass, setLoginScreenClass] = useState('bg5_2 color1');
  const [categoryScreenClass, setCategoryScreenClass] = useState('bg2_5 color2');
  const [ratePlanScreenClass, setRatePlanScreenClass] = useState('bg2_5 color2');

  const renderLoginScreen = () => {
    const {
      mappingParam: {
        channelHotelId,
        currency,
        channelId,
        username,
        password,
        sync
      },
      currencyList,
      handelParamChange
    } = props;
    
    return (
      <div className="wrapper" ng-show="loginScreen">
        <div id="ratecodediv" className="cover">
          <div className="cover">
            <div className="ovr marg_bottom5">Hotel Id</div>
            <div className="frm border_all_1 border_color_1">
              <input
                type="text"
                placeholder="Hotel Id"
                className="input pad_lft_rht10"
                value={channelHotelId}
                onChange={e => handelParamChange(e, '','channel_hotel_id')}
                disabled={sync === 'add' ? false : true}
              />
            </div>
          </div>
          {(sync === 'add' && channelId === 21255) && <div className="cover">
            <div className="ovr marg_bottom5">Username</div>
            <div className="frm border_all_1 border_color_1">
              <input
                type="text"
                placeholder="Username"
                className="input pad_lft_rht10"
                value={username}
                onChange={e => handelParamChange(e, '','username')}
              />
            </div>
          </div>}
          {(sync === 'add' && (channelId === 21255 || channelId === 21243)) && <div className="cover">
            <div className="ovr marg_bottom5">Password</div>
            <div className="frm border_all_1 border_color_1">
              <input
                type="password"
                placeholder="Password"
                className="input pad_lft_rht10"
                value={password}
                onChange={e => handelParamChange(e, '','password')}
              />
            </div>
          </div>}

          {sync === 'add' && <div className="cover margtop10">
            <div className="row">
              <div className="col-xs-12 col-md-4 marg_bottom15">
                <div className="ovr marg_bottom3 color2_9">Currency</div>
                <div className="frm border_all_1 border_color_1">
                  {' '}
                  <span className="ficon pad_lft_rht10">
                    <i className="fa fa-chevron-down"></i>
                  </span>
                  <select
                    className="input pad_lft_rht10"
                    value={currency}
                    onChange={e => handelParamChange(e, '','currency')}
                  >
                    <option value="">Select Currency</option>
                    {Object.keys(currencyList).map((id, i) => {
                      return (
                        <option key={i} value={currencyList[id]}>
                          {currencyList[id]}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
            </div>
          </div>}
        </div>
        <div className="cover fnt14 tr margtop10" aria-label="Pagination" role="menu">
          {(checkRole('edit_mapping') || checkRole('create_mapping'))
            ? <div className="inline align_middle marg_left10 cursor_p" role="menuitem">
              <a className="disblock pad_top_bot5 pad_lft_rht15 btn1" onClick={() => toggleNavigaton('getChannelConfig')}>Next</a>
            </div> : ''}
        </div>
      </div>
    );
  };

  const renderCategoryMappingScreen = () => {
    return (
      <div className="wrapper" >
        <div className="cover border_all_1 border_color_1" id="pmsDataHotel">
          <div className="table_col table_fixed">
            <div className="table_row bg2_8 border_b_1 border_color_1">
              <div className="tabcel align_middle pad10 channle_rates">Channel Room</div>
              <div className="tabcel align_middle pad10 system_rates">System Room</div>
            </div>
          </div>
          <div className="cover">
            <div className="table_col table_fixed">
              {populateCategoryMapping()}
            </div>
            <div className="ovr pad10 margtop10"><i className="fa fa-hand-o-right marg_right3"></i> BO Stands for Base Occupancy, MO Stands for Max Occupancy, ME Stands for Max Extrabed</div>
          </div>
        </div>
        <div className="cover fnt14 tr margtop10" aria-label="Pagination" role="menu">
          <div className="inline align_middle marg_left10 cursor_p" role="menuitem">
            <a className="disblock pad_top_bot5 pad_lft_rht15 btn1" onClick={() => toggleNavigaton('backToLoginScreen')}>Go Back</a>
          </div>
          <div className="inline align_middle marg_left10 cursor_p" role="menuitem">
            <a className="disblock pad_top_bot5 pad_lft_rht15 btn1" onClick={() => toggleNavigaton('getRatePlanScreen')}>Next</a>
          </div>
        </div>
      </div>
    );
  };

  const populateCategoryMapping = () => {
    const {
      channelConfigData,
      categoryOptionsObject,
      handelCategoryChange,
      handelParamChange,
      mappingParam: {
        mapping
      }
    } = props;
    
    // Check if channelConfigData exists and has mappedArray
    if (!channelConfigData || !channelConfigData.mappedArray) {
      return (
        <div className="table_row border_b_1 border_color_1">
          <div className="tabcel align_middle pad10 text-center" colSpan="2">
            <div className="fnt14 color2_9">Loading channel configuration...</div>
          </div>
        </div>
      );
    }
    
    const {
      mappedArray
    } = channelConfigData;
    
    // Check if mappedArray has categories
    if (!mappedArray.categories || Object.keys(mappedArray.categories).length === 0) {
      return (
        <div className="table_row border_b_1 border_color_1">
          <div className="tabcel align_middle pad10 text-center" colSpan="2">
            <div className="fnt14 color2_9">No channel rooms found to map.</div>
          </div>
        </div>
      );
    }
    
    return Object.keys(mappedArray.categories).map(mappedKey => {
        const mappedData = mappedArray.categories[mappedKey];
        return (
          <div key={mappedKey} className="table_row border_b_1 border_color_1">
            <div className="tabcel align_middle pad10">
              {mappedData.ota_cat_name}
              <span className="extradetails">{mappedData.maxoccstatement + mappedData.maxextrabed}</span>
            </div>

            <div className="tabcel align_middle pad10">
              <div className="cover">
                <div className="frm border_all_1 border_color_1">
                  <span className="ficon pad_lft_rht10"><i className="fa fa-chevron-down"></i></span>
                  <select
                    className="input pad_lft_rht10"
                    value={typeof mapping[mappedKey] !== 'undefined' ? mapping[mappedKey].pmsCatId : ''}
                    onChange={e => handelCategoryChange(e, mappedKey, 'category')}
                  >
                    <option value="">Select System Category</option>
                    {categoryOptionsObject && categoryOptionsObject[mappedKey] && Object.keys(categoryOptionsObject[mappedKey]).map((id, i) => {
                      return (
                        <option key={i} value={`${id}`}>
                          {categoryOptionsObject[mappedKey][id].pmsCatName}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
              <div className="cover margtop8">
                <div className="row gutters-5">
                  <div className="col-xs-4">
                    <div className="ovr marg_bottom3 color2_9">Decrease Inventory</div>
                    <div className="frm border_all_1 border_color_1">
                      <span className="ficon pad_lft_rht10"><i className="fa fa-chevron-down"></i></span>
                      <select
                        className="input pad_lft_rht10"
                        value={typeof mapping[mappedKey] !== 'undefined' ? mapping[mappedKey].decrease_inventory : ''}
                        onChange={e => handelParamChange(e, mappedKey, 'inventory')}
                      >
                        <option value="">Select Inventory</option>
                        {typeof mapping[mappedKey] !== 'undefined' && 
                         typeof mapping[mappedKey].pmsCatId !== 'undefined' && 
                         categoryOptionsObject && 
                         categoryOptionsObject[mappedKey] && 
                         categoryOptionsObject[mappedKey][mapping[mappedKey].pmsCatId] && 
                         categoryOptionsObject[mappedKey][mapping[mappedKey].pmsCatId].totalRoom && 
                         Object.keys(categoryOptionsObject[mappedKey][mapping[mappedKey].pmsCatId].totalRoom).map((id, i) => {
                          return (
                            <option key={i} value={id}>
                              {id}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                  <div className="col-xs-4">
                    <div className="ovr marg_bottom3 color2_9">Min Threshold</div>
                    <div className="frm border_all_1 border_color_1">
                      <input
                        type="text"
                        className="input pad_lft_rht10"
                        value={typeof mapping[mappedKey] !== 'undefined'
                          ? mapping[mappedKey].min_rate_threshold : ''}
                        onChange={e =>  (typeof mapping[mappedKey] !== 'undefined' && typeof mapping[mappedKey].pmsCatId !== 'undefined') ? handelParamChange(e, mappedKey, 'threshold') : null}/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      });
  };

  const renderRateplanMappingScreen = () => {
    return (
      <div className="wrapper" ng-show="ratePlanScreen">
        <div id="rateplantype" className="cover" src="ratePlanScreenUrl">
          {renderSelectedCategory()}
          <div className="ovr pad10 margtop10"><i className="fa fa-hand-o-right marg_right3"></i> BO Stands for Base Occupancy, MO Stands for Max Occupancy</div>
        </div>
        <div className="cover fnt14 tr margtop10" aria-label="Pagination" role="menu">
          <div className="inline align_middle marg_left10 cursor_p" role="menuitem">
            <a className="disblock pad_top_bot5 pad_lft_rht15 btn1" onClick={() => toggleNavigaton('backToCategoryScreen')}>Go Back</a>
          </div>
          <div className="inline align_middle marg_left10 cursor_p" role="menuitem">
            <a className="disblock pad_top_bot5 pad_lft_rht15 btn1" onClick={() => toggleNavigaton('submitData')}>Lets Start Selling</a>
          </div>
        </div>
      </div>
    );
  };

  const renderSelectedCategory = () => {
    const {
      channelConfigData,
      mappingParam: {
        mapping
      }
    } = props;
    
    // Check if channelConfigData exists and has mappedArray
    if (!channelConfigData || !channelConfigData.mappedArray) {
      return (
        <div className="cover pad30 text-center">
          <div className="fnt14 color2_9">Loading channel configuration...</div>
        </div>
      );
    }
    
    const {
      mappedArray
    } = channelConfigData;
    
    // Check if mappedArray has categories and mapping has content
    if (!mappedArray.categories || Object.keys(mapping).length === 0) {
      return (
        <div className="cover pad30 text-center">
          <div className="fnt14 color2_9">No room mappings configured yet.</div>
        </div>
      );
    }
    
    return Object.keys(mapping).map(otaCatId => {
        const value = mapping[otaCatId];
        return (
          <div key={otaCatId} className="cover">
            <div className="ovr fnt14 bld marg_bottom15">{mappedArray.categories[value.otaCatId].ota_cat_name} </div>

            <div className="cover border_all_1 border_color_1" id="pmsDataHotel">
              <div className="table_col table_fixed">
                <div className="table_row bg2_8">
                  <div className="tabcel align_middle pad10">Channel Rates</div>
                  <div className="tabcel align_middle pad10">System Rates</div>
                </div>
                {renderRateplanMapping(otaCatId)}
              </div>
            </div>
          </div>
        );
      });
  };

  const renderRateplanMapping = (otaCatId) => {
    const {
      handelParamChange,
      mappingParam: {
        mapping,
        sync
      }
    } = props;

    if (Object.keys(mapping[otaCatId].otaCatData.rateplans).length > 0) {
      return Object.keys(mapping[otaCatId].otaCatData.rateplans).map((channelRateplanId) => {
        const channelRatePlanDetails = mapping[otaCatId].otaCatData.rateplans[channelRateplanId];
        const channelCatDetail = mapping[otaCatId];
        return (
          <div key={channelRateplanId} className="table_row border_t_1 border_color_1">
            <div className="tabcel align_middle pad10">
              {`${channelRatePlanDetails.ota_rateplan_name} ${channelRatePlanDetails.maxoccstatement || ''}`}
            </div>
            <div className="tabcel align_top pad10">
              <div className="frm border_all_1 border_color_1">
                <select
                  multiple
                  className="input pad_lft_rht10"
                  value={typeof mapping[otaCatId].selectedRatePlans !== 'undefined' &&
                    typeof mapping[otaCatId].selectedRatePlans[channelRateplanId] !== 'undefined'
                    ? [mapping[otaCatId].selectedRatePlans[channelRateplanId].rateplanIds]
                    : []}
                  onChange={e => handelParamChange(e, otaCatId, 'rateplan')}
                >
                  {typeof mapping[otaCatId].pmsCatData !== 'undefined' &&
                    typeof mapping[otaCatId].pmsCatData.rateplans !== 'undefined' &&
                    Object.keys(mapping[otaCatId].pmsCatData.rateplans).map((val) => {
                      const pmsRateplanData = mapping[otaCatId].pmsCatData.rateplans[val];
                      return (
                        <option key={val} value={`${val}-${channelRateplanId}`}>
                          {`${pmsRateplanData.pms_rateplan_name} (${pmsRateplanData.pms_start} ${pmsRateplanData.pms_end})`}
                        </option>
                      );
                    })}
                </select>
              </div>

              <div className="col-xs-6 fl">
                <div className="ovr marg_bottom3 color2_9">Flat Markup</div>
                <div className="frm border_all_1 border_color_1">
                  <input
                    type="text"
                    className="input pad_lft_rht10"
                    placeholder="Enter value"
                    value={typeof mapping[otaCatId] !== 'undefined' &&
                      typeof mapping[otaCatId].selectedRatePlans !== 'undefined' &&
                      typeof mapping[otaCatId].selectedRatePlans[channelRateplanId] !== 'undefined' &&
                      mapping[otaCatId].selectedRatePlans[channelRateplanId].markup_rate_flat !== ''
                      ? mapping[otaCatId].selectedRatePlans[channelRateplanId].markup_rate_flat : ''}
                    onChange={e => handelParamChange(e, { otaCatId, channelRateplanId }, 'markup_rate_flat')}
                    disabled={sync === 'edit' && !checkRole('edit_markup') && !channelCatDetail.newMapping}
                  />
                </div>
              </div>
              <div className="col-xs-6 fl">
                <div className="ovr marg_bottom3 color2_9">Percentage Markup</div>
                <div className="frm border_all_1 border_color_1">
                  <input
                    type="text"
                    className="input pad_lft_rht10"
                    placeholder="Enter value"
                    value={typeof mapping[otaCatId] !== 'undefined' &&
                      typeof mapping[otaCatId].selectedRatePlans !== 'undefined' &&
                      typeof mapping[otaCatId].selectedRatePlans[channelRateplanId] !== 'undefined' &&
                      mapping[otaCatId].selectedRatePlans[channelRateplanId].markup_rate_per !== ''
                      ? mapping[otaCatId].selectedRatePlans[channelRateplanId].markup_rate_per : ''}
                    onChange={e => handelParamChange(e, { otaCatId, channelRateplanId }, 'markup_rate_per')}
                    disabled={sync === 'edit' && !checkRole('edit_markup') && !channelCatDetail.newMapping}
                  />
                </div>
              </div>
              {/* add system rateplans for redpartnar  */}

              { isEzakey
                ? (<div>
                  <div className="col-xs-6 fl">
                    <div className="ovr marg_bottom3 color2_9">Fixed Price</div>
                    <div className="frm border_all_1 border_color_1">
                      <input
                        type="text"
                        className="input pad_lft_rht10"
                        placeholder="Enter value"
                        value={typeof mapping[otaCatId] !== 'undefined' &&
                          typeof mapping[otaCatId].selectedRatePlans !== 'undefined' &&
                          typeof mapping[otaCatId].selectedRatePlans[channelRateplanId] !== 'undefined' &&
                          mapping[otaCatId].selectedRatePlans[channelRateplanId].manual_price !== ''
                          ? mapping[otaCatId].selectedRatePlans[channelRateplanId].manual_price : ''}
                        onChange={e => handelParamChange(e, { otaCatId, channelRateplanId }, 'manual_price')}
                      />
                    </div>
                  </div>

                  {/* <div className="col-xs-6 fl">
                    <div className="ovr marg_bottom3 color2_9">System Rate Plan</div>
                    <div className="frm border_all_1 border_color_1">
                      {' '}
                      <span className="ficon pad_lft_rht10">
                        <i className="fa fa-chevron-down"></i>
                      </span>
                      <select
                        multiple={false}
                        className="input pad_lft_rht10"
                        value={typeof mapping[otaCatId].selectedRatePlans !== 'undefined' &&
                          typeof mapping[otaCatId].selectedRatePlans[channelRateplanId] !== 'undefined'
                          ? mapping[otaCatId].selectedRatePlans[channelRateplanId].system_rate_plan_code
                          : ''}
                        onChange={e => handelParamChange(e, 'systemRateplan', { otaCatId, channelRateplanId })}
                      >
                        <option value=''> Select Rate Plan</option>
                        {typeof mapping[otaCatId].pmsCatData !== 'undefined' &&
                          typeof mapping[otaCatId].pmsCatData.rateplans !== 'undefined' &&

                          Object.entries(systemRatePlan).map(([key, value]) => {
                            return (
                              <option key={key} value={key}>
                                {value}
                              </option>
                            );
                          }

                          )}
                      </select>
                    </div>
                  </div> */}
                </div>
                )
                : ('')}

              {/* system rate plan end */}
            </div>
          </div>
        );
      });
    }
  };

  const toggleNavigaton = (gotoScreen) => {
    const {
      setChannelConfig,
      getChannelConfig,
      channelConfigData,
      mappingParam,
      showConfigMessage
    } = props;
    
    showConfigMessage(false, '');
    const error = validateMappingParams(mappingParam, gotoScreen);
    
    if (!error && gotoScreen === 'backToLoginScreen') {
      setShowLogin(true);
      setShowCategoryMapping(false);
      setShowRateplanMapping(false);
      setLoginScreenClass('bg5_2 color1');
      setCategoryScreenClass('bg2_5 color2');
      setRatePlanScreenClass('bg2_5 color2');
    } else if (!error && gotoScreen === 'getChannelConfig') {
      setShowLogin(false);
      setShowCategoryMapping(true);
      setShowRateplanMapping(false);
      setLoginScreenClass('bg5_3 color2');
      setCategoryScreenClass('bg5_2 color1');
      setRatePlanScreenClass('bg2_5 color2');
    } else if (!error && gotoScreen === 'backToCategoryScreen') {
      setShowLogin(false);
      setShowCategoryMapping(true);
      setShowRateplanMapping(false);
      setLoginScreenClass('bg5_3 color2');
      setCategoryScreenClass('bg5_2 color1');
      setRatePlanScreenClass('bg2_5 color2');
    } else if (!error && gotoScreen === 'getRatePlanScreen') {
      setShowLogin(false);
      setShowCategoryMapping(false);
      setShowRateplanMapping(true);
      setLoginScreenClass('bg5_3 color2');
      setCategoryScreenClass('bg5_3 color2');
      setRatePlanScreenClass('bg5_2 color1');
    } else if (!error && gotoScreen === 'submitData') {
      setChannelConfig();
    }
    
    if (!error && (gotoScreen === 'getChannelConfig' && Object.keys(channelConfigData).length === 0)) {
      getChannelConfig('add').then((res) => {
        if (res === true) {
          setShowLogin(false);
          setShowCategoryMapping(true);
          setShowRateplanMapping(false);
          setLoginScreenClass('bg5_3 color2');
          setCategoryScreenClass('bg5_2 color1');
          setRatePlanScreenClass('bg2_5 color2');
        }
      });
    }
  };

  const validateMappingParams = (mappingParam, gotoScreen) => {
    const {
      showConfigMessage
    } = props;
    
    if (gotoScreen === 'getChannelConfig') {
      if (typeof mappingParam.channelHotelId === 'undefined' || mappingParam.channelHotelId === '') {
        showConfigMessage(true, 'Hotel Id cannot be empty');
        return true;
      } else if (mappingParam.sync === 'add' && mappingParam.channelId === 21255 && (mappingParam.username === '' || mappingParam.password === '')) {
        showConfigMessage(true, 'Username and password cannot be empty');
        return true;
      } else if (mappingParam.sync === 'add' && mappingParam.channelId === 21243 && mappingParam.password === '') {
        showConfigMessage(true, 'Password cannot be empty');
        return true;
      }
    }
    else if (gotoScreen === 'getRatePlanScreen') {
      if (Object.keys(mappingParam.mapping).length <= 0) {
        showConfigMessage(true, 'Please select at least one system room');
        return true;
      } else {
        let error = false;
        Object.keys(mappingParam.mapping).map((val) => {
          const data = mappingParam.mapping[val];
          if (typeof data.min_rate_threshold === 'undefined' || data.min_rate_threshold === '') {
            showConfigMessage(true, 'Please provide minimum threshold');
            error = true;
            return true;
          }
        });
        return error;
      }
    } else if (gotoScreen === 'submitData') {
      let error = false;
      Object.keys(mappingParam.mapping).map((val) => {
        const data = mappingParam.mapping[val];
        if (typeof data.otaRateplanId === 'undefined' || typeof data.pmsCatId === 'undefined') {
          showConfigMessage(true, 'Please select system rates');
          error = true;
          return true;
        }
        // if (isEzakey) {
        //   console.log(data, '-------------');
        //   Object.keys(data.selectedRatePlans).map((val) => {
        //     const systemRpData = data.selectedRatePlans[val];
        //     console.log(systemRpData, 'systemRpData');
        //     if (typeof systemRpData.system_rate_plan_code === 'undefined' || systemRpData.system_rate_plan_code == '') {
        //       showConfigMessage(true, 'Please select system rate plan code');
        //       error = true;
        //       return true;
        //     }
        //   });
        // }
      });
      return error;
    }
    return false;
  };

  const { channelConfigData, otaData, showError, errorMessage } = props;
  
  return (
    <div className="wrapper">
      <div className="cover">
        <div className="row">
          <div className="col-xs-12 col-md-10 offset-md-1 marg_bottom15">
            <div className="cover marg_bottom5">
              <div className="row gutters-5" role="tablist">
                <div className="col-xs-auto">
                  <div className={`cover fnt16 pad_top_bot7 pad_lft_rht15 ${loginScreenClass}`} id="wizard-t-0" role="tab">
                    <div className="row gutters-5">
                      <div className="col-xs-auto">
                        <div className="inline full-round bg1 color4_1">
                          <div className="icon_size3">
                            <div className="icon_center">1</div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xs">
                        <span className="hides">Current Step: </span>
                        {Object.keys(channelConfigData).length > 0 && typeof otaData.connected !== 'undefined' ? <span >Rate Code</span> : <span>Connect to Channel</span>}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xs-auto">
                  <div className={`cover fnt16 pad_top_bot7 pad_lft_rht15 ${categoryScreenClass}`} id="wizard-t-1" role="tab">
                    <div className="row gutters-5">
                      <div className="col-xs-auto">
                        <div className="inline full-round  bg1 color4_1">
                          <div className="icon_size3">
                            <div className="icon_center">2</div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xs">Map Rooms</div>
                    </div>
                  </div>
                </div>

                <div className="col-xs-auto">
                  <div className={`cover fnt16 pad_top_bot7 pad_lft_rht15 ${ratePlanScreenClass}`} id="wizard-t-2" role="tab">
                    <div className="row gutters-5">
                      <div className="col-xs-auto">
                        <div className="inline full-round  bg1 color4_1">
                          <div className="icon_size3">
                            <div className="icon_center">3</div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xs">Map Rates</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="wrapper pad10 border_all_1 border_color_1 fnt14">
              {showError && <div className="ovr pad10 danger marg_bottom10">
                <div className="ovr">
                  {errorMessage}
                </div>
              </div>}
              {showLogin && renderLoginScreen()}
              {showCategoryMapping && renderCategoryMappingScreen()}
              {showRateplanMapping && renderRateplanMappingScreen()}
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default EditMapping;
